export default __webpack_public_path__ + "static/media/4690@3x.ca34134b.png";